module.exports = __webpack_public_path__ + "img/aprender-icon.c14027e4.png";